if (!customElements.get("social-media-highlights-slider")) {
  class SocialMediaHighlightsSlider extends HTMLElement {
    constructor() {
      super();

      /** Store Content Card before initilation */
      this.slideContent = this.querySelector('.section__social-media-highlights--content-card');

      /** Swiper opts & init */
      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      const swiperLayout = this.getAttribute("data-swiper-layout") || "default";

      this.sliderItem = this.querySelector('.swiper');

      this.sliderOptions = {
        slidesPerView: 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          }
        },
        on: {
          afterInit: () =>
            this.querySelector(".swiper-smh").removeAttribute("style")
        }
      };

      if (swiperOptions.autoplaySpeed != 0 && swiperLayout === "default") {
        this.sliderOptions = {
          speed: swiperOptions.autoplaySpeed || 10000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "default" ) {
        this.sliderOptions = {
          loop: true,
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "stacked") {
        this.sliderOptions = {
          navigation: {
            prevEl: ".swiper-button--prev",
            nextEl: ".swiper-button--next"
          },
          ...this.sliderOptions
        };
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.swiper = new Swiper(this.sliderItem, this.sliderOptions);
      this.toggleSlideContentCard();
    }

    /** Hide / Show Content Card */
    toggleSlideContentCard() {
      let swiperInitialized = false;
      if (DeviceDetector.isMobile()) {
        this.swiper.removeSlide(2);
      }

      const updateSlideContent = () => {
        if (swiperInitialized) {
          if (DeviceDetector.isMobile()) {
            this.swiper.removeSlide(2);
          } else {
            this.swiper.addSlide(2, this.slideContent)
          }
        }
      };

      updateSlideContent();

      window.addEventListener(
        "resize",
        debounce(() => {
          updateSlideContent();
        }, 200)
      );

      this.addEventListener("swiper:init", () => {
        swiperInitialized = true;
      });
    }
  }

  customElements.define("social-media-highlights-slider", SocialMediaHighlightsSlider);
}

/* [BB-AUTOPLAY] Swiper'siz otomatik kaydirma — panel hizini (autoplaySpeed) okur */
(function(){
  function start(){
    document.querySelectorAll('social-media-highlights-slider').forEach(function(el){
      if (el.dataset.bbAutoplay) return;
      el.dataset.bbAutoplay = '1';
      var speed = 4000;
      try {
        var opts = JSON.parse(el.getAttribute('data-swiper-options') || '{}');
        if (opts.autoplaySpeed) speed = Number(opts.autoplaySpeed) < 100 ? Number(opts.autoplaySpeed) * 1000 : Number(opts.autoplaySpeed);
      } catch(e){}
      if (!speed) return; // 0 = kapali
      var w = el.querySelector('.swiper-wrapper');
      if (!w) return;
      var pausedUntil = 0;
      ['pointerdown','touchstart','wheel'].forEach(function(ev){
        w.addEventListener(ev, function(){ pausedUntil = Date.now() + 8000; }, {passive:true});
      });
      el.addEventListener('mouseenter', function(){ pausedUntil = Date.now() + 4000; });
      setInterval(function(){
        if (document.hidden || Date.now() < pausedUntil) return;
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return; // ekranda degilse durma
        var slide = w.querySelector('.swiper-slide');
        if (!slide) return;
        var step = slide.getBoundingClientRect().width;
        var max = w.scrollWidth - w.clientWidth;
        var next = w.scrollLeft + step;
        var target = next > max - 8 ? 0 : next;
        var startPos = w.scrollLeft, dist = target - startPos, t0 = performance.now();
        w.style.scrollSnapType = 'none';
        requestAnimationFrame(function anim(ts){
          var p = Math.min((ts - t0) / 450, 1);
          w.scrollLeft = startPos + dist * (1 - Math.pow(1 - p, 3));
          if (p < 1) requestAnimationFrame(anim);
          else w.style.scrollSnapType = '';
        });
      }, speed);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
